export class LingEntity {
  _id?: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(lingEntity?: LingEntity) {
    if (lingEntity) {
      Object.assign(this, lingEntity);
    }

    if (this.createdAt) {
      this.createdAt = new Date(this.createdAt);
    }
    if (this.updatedAt) {
      this.updatedAt = new Date(this.updatedAt);
    }
  }
}
